import React, { useState, useCallback } from 'react';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt = n => n?Number(n).toLocaleString('fa-IR'):'•';

async function API(path, opts={}) {
  const doFetch = () => fetch(`/api/accounting${path}`, {
    headers: { 'Content-Type':'application/json',
               Authorization:`Bearer ${localStorage.getItem('access')}` }, ...opts,
  });
  let res = await doFetch();
  if (res.status === 401) {
    const refresh = localStorage.getItem('refresh');
    if (refresh) {
      const rr = await fetch('/api/auth/token/refresh/', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ refresh }),
      });
      if (rr.ok) {
        const data = await rr.json();
        localStorage.setItem('access', data.access);
        if (data.refresh) localStorage.setItem('refresh', data.refresh);
        res = await doFetch();
      }
    }
  }
  return res.json();
}

export default function DocumentControlModal({ doc, year, onClose, onClosedDoc }) {
  const [closing, setClosing] = useState(false);
  // بستن سند: سند بدون خطا ⇒ IsClosed=1 (سرور کنترل را دوباره اجرا می‌کند)
  const closeDocument = async () => {
    setClosing(true); setError('');
    const j = await API(`/documents/${doc.id}/close/?year=${year}`, { method:'POST', body:'{}' });
    setClosing(false);
    if (j.ok) { onClosedDoc ? onClosedDoc() : onClose(); }
    else setError(j.msg);
  };
  const [result,  setResult]  = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const runControl = useCallback(async () => {
    setLoading(true); setError(''); setResult(null);
    const j = await API(`/documents/${doc.id}/control/?year=${year}`);
    setLoading(false);
    if (j.ok) setResult(j);
    else setError(j.msg);
  }, [doc.id, year]);

  // اجرای خودکار هنگام باز شدن
  React.useEffect(() => { runControl(); }, []); // eslint-disable-line

  const criticals = result?.errors?.filter(e => e.level === 'critical') || [];
  const warnings  = result?.errors?.filter(e => e.level === 'warning')  || [];

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>

        {/* هدر */}
        <div style={s.mHeader}>
          <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
            <span style={{fontSize:'18px'}}>🔍</span>
            <div>
              <div style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>
                کنترل سند شماره {toFa(doc.document_no)}
              </div>
              <div style={{fontSize:'11px',color:'rgba(255,255,255,0.65)'}}>
                {doc.document_date} — {doc.document_remark}
              </div>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            <button onClick={runControl} disabled={loading}
              style={{padding:'6px 14px',background:'rgba(255,255,255,0.15)',
                color:'#fff',border:'1px solid rgba(255,255,255,0.3)',borderRadius:'7px',
                cursor:loading?'default':'pointer',fontFamily:'inherit',fontSize:'12px'}}>
              {loading?'⏳ در حال بررسی...':'↺ اجرای مجدد'}
            </button>
            <button onClick={onClose} style={s.closeBtn}>✕</button>
          </div>
        </div>

        <div style={s.body}>
          {loading && (
            <div style={s.loadingBox}>
              <div style={{fontSize:'36px',marginBottom:'12px'}}>⏳</div>
              <div style={{fontSize:'14px',color:'#555'}}>در حال کنترل سند...</div>
              <div style={{fontSize:'12px',color:'#999',marginTop:'6px'}}>
                بررسی تراز، اقلام و الزامات هر آرتیکل
              </div>
            </div>
          )}

          {error && (
            <div style={s.errBox}>⚠️ {error}</div>
          )}

          {result && !loading && (
            <>
              {/* خلاصه وضعیت */}
              <div style={{
                ...s.statusBox,
                background: result.is_ok ? 'linear-gradient(135deg,#1b5e20,#2e7d32)'
                           : criticals.length > 0 ? 'linear-gradient(135deg,#b71c1c,#c62828)'
                           : 'linear-gradient(135deg,#e65100,#f57c00)',
              }}>
                <div style={{fontSize:'32px'}}>
                  {result.is_ok ? '✅' : criticals.length > 0 ? '🚫' : '⚠️'}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:'16px',fontWeight:'700',color:'#fff'}}>
                    {result.is_ok
                      ? 'سند از نظر شکلی مشکلی ندارد'
                      : criticals.length > 0
                        ? 'سند دارای خطای بحرانی است'
                        : `سند دارای ${toFa(warnings.length)} هشدار است`}
                  </div>
                  <div style={{fontSize:'12px',color:'rgba(255,255,255,0.85)',marginTop:'4px',display:'flex',gap:'16px'}}>
                    <span>اقلام: {toFa(result.item_count)}</span>
                    <span>بدهکار: {numFmt(result.sum_debit)}</span>
                    <span>بستانکار: {numFmt(result.sum_credit)}</span>
                    {result.sum_debit !== result.sum_credit && (
                      <span style={{fontWeight:'700'}}>
                        مانده: {numFmt(Math.abs(result.sum_debit - result.sum_credit))}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* جدول خطاها */}
              {result.errors.length > 0 && (
                <div style={{marginTop:'14px'}}>
                  <div style={{fontSize:'13px',fontWeight:'700',color:'#1a2f50',
                    marginBottom:'8px',display:'flex',alignItems:'center',gap:'8px'}}>
                    <span>نتایج کنترل</span>
                    {criticals.length > 0 && (
                      <span style={{background:'#b71c1c',color:'#fff',padding:'2px 8px',
                        borderRadius:'10px',fontSize:'11px'}}>
                        {toFa(criticals.length)} خطای بحرانی
                      </span>
                    )}
                    {warnings.length > 0 && (
                      <span style={{background:'#e65100',color:'#fff',padding:'2px 8px',
                        borderRadius:'10px',fontSize:'11px'}}>
                        {toFa(warnings.length)} هشدار
                      </span>
                    )}
                  </div>
                  <div style={{overflowX:'auto',borderRadius:'10px',
                    boxShadow:'0 2px 8px rgba(0,0,0,0.1)'}}>
                    <table style={{width:'100%',borderCollapse:'collapse'}}>
                      <thead>
                        <tr>
                          <th style={s.th}>ردیف</th>
                          <th style={s.th}>حساب معین</th>
                          <th style={{...s.th,background:'#1a3a2a',color:'#ef9a9a'}}>بدهکار</th>
                          <th style={{...s.th,background:'#0d3020',color:'#a5d6a7'}}>بستانکار</th>
                          <th style={{...s.th,textAlign:'right',minWidth:'200px'}}>خطا / هشدار</th>
                          <th style={s.th}>سطح</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.errors.map((e,i) => (
                          <tr key={i} style={{
                            background: e.level==='critical'
                              ? '#fff3f3'
                              : i%2===0?'#fff':'#fffbf0',
                          }}>
                            <td style={s.td}>{toFa(e.paper_no)||'—'}</td>
                            <td style={s.td}>{toFa(e.sub_code)||'—'}</td>
                            <td style={{...s.td,textAlign:'left',fontFamily:'monospace',
                              color:e.debit>0?'#b71c1c':'#ccc',fontWeight:'700',paddingLeft:'10px'}}>
                              {e.debit>0?numFmt(e.debit):'•'}
                            </td>
                            <td style={{...s.td,textAlign:'left',fontFamily:'monospace',
                              color:e.credit>0?'#1b5e20':'#ccc',fontWeight:'700',paddingLeft:'10px'}}>
                              {e.credit>0?numFmt(e.credit):'•'}
                            </td>
                            <td style={{...s.td,textAlign:'right',fontWeight:'600',
                              color:e.level==='critical'?'#b71c1c':'#e65100'}}>
                              {e.error_text}
                            </td>
                            <td style={{...s.td,textAlign:'center'}}>
                              {e.level==='critical'
                                ? <span style={{background:'#b71c1c',color:'#fff',
                                    padding:'2px 7px',borderRadius:'4px',fontSize:'10px',fontWeight:'700'}}>
                                    بحرانی
                                  </span>
                                : <span style={{background:'#fff3e0',color:'#e65100',
                                    padding:'2px 7px',borderRadius:'4px',fontSize:'10px',fontWeight:'700'}}>
                                    هشدار
                                  </span>
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* وقتی سند مشکل ندارد */}
              {result.is_ok && (
                <div style={{marginTop:'14px',background:'#e8f5e9',border:'1px solid #a5d6a7',
                  borderRadius:'10px',padding:'16px 20px',display:'flex',gap:'12px',alignItems:'center'}}>
                  <span style={{fontSize:'24px'}}>🎉</span>
                  <div>
                    <div style={{fontWeight:'700',color:'#1b5e20',fontSize:'14px'}}>
                      سند از نظر شکلی مشکلی ندارد
                    </div>
                    <div style={{fontSize:'12px',color:'#388e3c',marginTop:'3px'}}>
                      تمام الزامات حساب‌های معین رعایت شده است
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <div style={s.footer}>
          <span style={{fontSize:'12px',color:'#999'}}>
            سال مالی: {toFa(year)}
          </span>
          <span style={{display:'flex',gap:'8px'}}>
            {result && result.is_ok && !result.is_closed && (
              <button onClick={closeDocument} disabled={closing}
                style={{...s.btnClose, background:'linear-gradient(135deg,#e65100,#f57c00)'}}>
                {closing ? '⏳' : '🔒 دائم کردن سند'}
              </button>
            )}
            <button onClick={onClose} style={s.btnClose}>بستن</button>
          </span>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,
              display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'900px',
              maxHeight:'90vh',display:'flex',flexDirection:'column',
              boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden'},
  mHeader:   {display:'flex',justifyContent:'space-between',alignItems:'center',
              padding:'14px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',
              flexShrink:0},
  body:      {flex:1,overflowY:'auto',padding:'16px'},
  footer:    {display:'flex',justifyContent:'space-between',alignItems:'center',
              padding:'10px 16px',borderTop:'1px solid #e0e0e0',
              background:'#fff',flexShrink:0},
  closeBtn:  {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',
              color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',
              fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  btnClose:  {padding:'7px 20px',background:'linear-gradient(135deg,#37474f,#455a64)',
              color:'#fff',border:'none',borderRadius:'7px',cursor:'pointer',
              fontFamily:'inherit',fontSize:'12px'},
  loadingBox:{textAlign:'center',padding:'60px 20px'},
  errBox:    {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',
              padding:'10px 14px',color:'#c62828',fontSize:'13px',margin:'8px 0'},
  statusBox: {display:'flex',alignItems:'center',gap:'16px',borderRadius:'12px',
              padding:'16px 20px',color:'#fff'},
  th:        {padding:'8px 10px',background:'#1a2f50',color:'#fff',fontWeight:'700',
              textAlign:'center',whiteSpace:'nowrap',fontSize:'12px',
              borderLeft:'1px solid rgba(255,255,255,0.1)',position:'sticky',top:0,zIndex:2},
  td:        {padding:'7px 9px',borderBottom:'1px solid #f0f0f0',
              fontSize:'12px',textAlign:'center',whiteSpace:'nowrap'},
};
